import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import totalResultByAttributes from "models/TotalResultByAttributes";

ReactHighcharts.Highcharts.setOptions({
  colors: ["#ffd46a", "#fff16f", "#C0D860", "#60b3dd", "#678ecc"]
});

class TotalResultByAttributes extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.data !== this.props.data;
  }
  render() {
    return (
      <Fragment>
        <ReactHighcharts
          config={totalResultByAttributes(
            this.props.data.filter(item=>item.data.length),
            this.props.xCategories
          )}
        />
      </Fragment>
    );
  }
}

TotalResultByAttributes.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  xCategories: PropTypes.array.isRequired
};

export default TotalResultByAttributes;



// WEBPACK FOOTER //
// ./src/components/ReportDetail/TotalResultByAttributes.jsx